import React from 'react';
import { Link } from 'react-router-dom';
import 'css/Header.css';
import NavMenu from 'components/NavMenu';

const Header: React.FC = () => {
  return (
    <header className="header background-stripes">
      <div id="site-name">
        <Link to="/">Fat Scientist</Link>
      </div>
      {/* <ul className="nav-links">
        <li>
          <Link to="/dosage-calculator">Dosage Calculator</Link>
        </li>
        <li>
          <Link to="/reverse-dosage-calculator">Reverse Dose Calculator</Link>
        </li>
        <li>
          <Link to="/about">About</Link>
        </li>
      </ul> */}
      {/* <NavMenu /> */}
    </header>
  );
};

export default Header;
